/**
 * Performance page routes every tab shares: the building's benchmark, the operator
 * leaderboard and the performance summary. Each tab's own routes live in
 * performance-<tab>.ts. `tier` grades against one geographic peer tier and `caseMix`
 * ranks staffing on the CMS case-mix adjusted hours; both are served.
 */
import { route } from './route';
import { AITHORA_PREFIX } from './prefix';
import type { FacilityBenchmark, Leaderboard, PerformanceSummary, PerfQuery, ReferenceBenchmarks } from './performance-types';

const A = AITHORA_PREFIX;

/** GET /api/aithora/my-facility/benchmark: a Facility Admin's own building (the session's CCN). */
export const myFacilityBenchmark = route<FacilityBenchmark, Pick<PerfQuery, 'tier' | 'caseMix'>>()('GET', `${A}/my-facility/benchmark`);
/** GET /api/financial/facilities/benchmarks/all: every facility the operator manages, graded, best first (facilities: the switcher's pick). */
export const facilitiesLeaderboard = route<Leaderboard, Pick<PerfQuery, 'tier' | 'caseMix'> & { facilities?: string }>()('GET', '/api/financial/facilities/benchmarks/all');
/** GET /api/aithora/performance/summary: attribution, peer percentile and fee schedule for one building. */
export const performanceSummary = route<PerformanceSummary, { facility?: string; period?: string }>()('GET', `${A}/performance/summary`, { honest: true });

/** GET /api/aithora/benchmarks/reference: the national reference figures (CMS Care Compare averages, catalog occupancy quartiles), each with its source and date. */
export const referenceBenchmarks = route<ReferenceBenchmarks>()('GET', `${A}/benchmarks/reference`);

export const performanceApi = { myFacilityBenchmark, facilitiesLeaderboard, performanceSummary, referenceBenchmarks } as const;
